// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessJerryCan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 4v1h4V4a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5zM6 5.17V4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.01a3 3 0 0 1 1.35.448l1.078-1.077a2 2 0 0 1 2.828 0l1.488 1.488a2 2 0 0 1 0 2.828l-1.11 1.11A3 3 0 0 1 19 11.243V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V8c0-1.306.835-2.417 2-2.83zm9.465 1.295L17.66 8.66l1.023-1.023a.5.5 0 0 0 0-.707l-1.487-1.488a.5.5 0 0 0-.708 0zM7 7a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-7.757a1 1 0 0 0-.293-.708l-3.243-3.242A1 1 0 0 0 12.758 7zm1.53 10.844-.374-.375a.531.531 0 0 1 0-.751l2.217-2.218-2.217-2.218a.531.531 0 0 1 0-.751l.375-.375a.531.531 0 0 1 .751 0l2.218 2.217 2.218-2.217a.531.531 0 0 1 .751 0l.375.375a.531.531 0 0 1 0 .751L12.627 14.5l2.217 2.218a.531.531 0 0 1 0 .751l-.375.375a.531.531 0 0 1-.751 0L11.5 15.627l-2.218 2.217a.531.531 0 0 1-.751 0z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessJerryCan;
